import { create } from 'zustand'
import { v4 as uuidv4 } from 'uuid'

// 玩创模式状态管理
export const usePlayCreateStore = create((set, get) => ({
  // 角色列表
  characters: [],
  
  // 当前选中的角色
  currentCharacter: null,
  
  // 当前聊天会话的消息
  currentMessages: [],
  
  // 当前对话选项（角色说话后显示的2个选项）
  currentOptions: [],
  
  // 加载角色列表
  loadCharacters: async () => {
    try {
      const playCreateStorageService = (await import('../services/playCreateStorageService')).default
      const characters = await playCreateStorageService.getAllCharacterProfiles()
      set({ characters })
      return characters
    } catch (error) {
      console.error('加载角色列表失败:', error)
      return []
    }
  },
  
  // 选择角色
  selectCharacter: (character) => {
    set({ currentCharacter: character })
  },
  
  // 添加消息
  addMessage: (message) => {
    const newMessage = {
      id: uuidv4(),
      ...message,
      timestamp: message.timestamp || Date.now()
    }
    set((state) => ({
      currentMessages: [...state.currentMessages, newMessage]
    }))
    return newMessage
  },
  
  // 设置对话选项
  setOptions: (options) => {
    set({ currentOptions: options })
  },
  
  // 清除对话选项
  clearOptions: () => {
    set({ currentOptions: [] })
  },
  
  // 更新角色状态（好感度等）
  updateCharacterState: (characterId, updates) => {
    set((state) => ({
      characters: state.characters.map(char =>
        char.id === characterId ? { ...char, ...updates } : char
      ),
      currentCharacter: state.currentCharacter?.id === characterId
        ? { ...state.currentCharacter, ...updates }
        : state.currentCharacter
    }))
  },
  
  // 重置当前会话
  resetCurrentSession: () => {
    set({
      currentCharacter: null,
      currentMessages: [],
      currentOptions: []
    })
  }
}))

